import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";

const ROW_KEYS = ["city", "source", "financials", "feasibility", "decision"];

export default function WhyNotChatGPT({ onCta }) {
  const { t } = useTranslation();
  return (
    <section className="py-16 bg-slate-50 border-t border-slate-200 cv-auto" data-testid="landing-why-not-chatgpt">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-slate-900 mb-10">
          {t("why_not_chatgpt.title_prefix")} <span className="text-blue-600">{t("why_not_chatgpt.title_accent")}</span>{t("why_not_chatgpt.title_suffix", "")}
        </h2>

        <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
          <div className="hidden md:grid grid-cols-12 bg-slate-100 border-b border-slate-200 font-semibold text-slate-700 py-3.5 px-6 text-sm md:text-base">
            <div className="col-span-3 text-slate-900">{t("why_not_chatgpt.col_feature")}</div>
            <div className="col-span-4 text-slate-500">ChatGPT</div>
            <div className="col-span-5 text-slate-900 font-bold">VentureKhoj</div>
          </div>

          {ROW_KEYS.map((k, i) => (
            <div
              key={k}
              data-testid={`why-not-chatgpt-row-${i + 1}`}
              className={"grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-0 py-4 px-6 text-sm text-slate-600 items-center hover:bg-slate-50/50 " +
                (i < ROW_KEYS.length - 1 ? "border-b border-slate-100" : "")}
            >
              <div className="md:col-span-3 font-semibold text-slate-900 text-base md:text-sm">{t(`why_not_chatgpt.rows.${k}.feature`)}</div>
              <div className="md:col-span-4 md:pr-2 text-slate-500">
                <span className="md:hidden text-[11px] uppercase tracking-wide text-slate-400 mr-1">ChatGPT:</span>{t(`why_not_chatgpt.rows.${k}.gpt`)}
              </div>
              <div className="md:col-span-5 font-semibold text-slate-900">
                <span className="md:hidden text-[11px] uppercase tracking-wide text-emerald-700 mr-1">VentureKhoj:</span>{t(`why_not_chatgpt.rows.${k}.vk`)}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 text-center">
          <Button
            data-testid="why-not-chatgpt-cta"
            onClick={onCta}
            className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white px-7 py-6 text-base font-semibold btn-hover-lift"
          >
            <Sparkles className="mr-2 h-4 w-4" />
            {t("why_not_chatgpt.cta")}
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
          <p className="text-xs text-slate-500">{t("why_not_chatgpt.cta_note")}</p>
        </div>
      </div>
    </section>
  );
}
